import { HostBinding, Component, Input, TemplateRef } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: `suka-avatar`,
  template: `
    <ng-container *ngIf="!imgSrc">{{getInitials()}}</ng-container>
    <img *ngIf="imgSrc" [src]="imgSrc" />
  `
})
export class Avatar {
  @Input() imgSrc: string;

  @Input() name: string;

  @Input() color: 'blue' | 'azure' | 'indigo' | 'purple' | 'pink' | 'red' | 'orange' |
  'yellow' | 'lime' | 'green' | 'teal' | 'cyan' | 'gray' | 'gray-dark' = 'gray';

  @Input() class = '';

  @Input() size: 'sm' | 'md' | 'lg' | 'xl' | '2xl' = 'md';

  @HostBinding('attr.class') get attrClass() {
    return `avatar avatar--${this.color} avatar--${this.size} ${this.class}`;
  }

  getInitials(): string {
    if (this.name === '') {
      return '';
    }

    const names = this.name.split(' ');
    let initials = names[0].substring(0, 1).toUpperCase();

    if (names.length > 1) {
      initials += names[names.length - 1].substring(0, 1).toUpperCase();
    }
    return initials;
  }
}
